import * as React from "react";

import { StatusProxy } from "@focus/focusUI";
import { GraphsTabs } from "@focus/focusGrafos";
import { GraphDataProvider } from "@focus/focusGrafos/lib/DataHandler";
import { GraphConfigurationProvider } from "@focus/focusGrafos/lib/ConfigurationHandler";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";

import { useGrafosConfig, useGrafosDat } from "../../services/grafos/index";
import { FolderType } from "@focus/focusGrafos/lib/interfaces/config";

interface GrafosBuilderProps {
  id: number;
}

export const GrafosBuilder: React.FC<GrafosBuilderProps> = ({ id }) => {
  const getProxyStatus = (configStatus: ItemStatus, datStatus: ItemStatus) => {
    if (configStatus === ItemStatus.ERROR || datStatus === ItemStatus.ERROR) {
      return ItemStatus.ERROR;
    } else if (
      configStatus === ItemStatus.PENDING ||
      datStatus === ItemStatus.PENDING
    ) {
      return ItemStatus.PENDING;
    } else {
      return ItemStatus.READY;
    }
  };

  const getProxyError = (configError: string, datError: string) => {
    if (
      configError &&
      configError.length > 0 &&
      datError &&
      datError.length > 0
    ) {
      return configError + "\n" + datError;
    } else {
      return configError + datError;
    }
  };

  const grafosConfig = React.useMemo(() => ({ id }), [id]);
  const {
    status: configStatus,
    error: configError,
    value: configValue,
  } = useGrafosConfig(grafosConfig);
  const {
    status: datStatus,
    error: datError,
    value: datValue,
  } = useGrafosDat(grafosConfig);

  const tabs = React.useMemo(() => {
    let tabs = [];
    if (configValue?.selectorFolderList) {
      tabs = configValue.selectorFolderList.flatMap((selector) =>
        selector.selectorList.flatMap((disp) => disp.tabs.map((tab) => tab)),
      );
    }
    return tabs;
  }, [configValue]);

  const safeConfig = React.useMemo(
    () => structuredClone(configValue),
    [configValue],
  );
  const safeDat = React.useMemo(() => structuredClone(datValue), [datValue]);

  return (
    <StatusProxy
      status={getProxyStatus(configStatus, datStatus)}
      error={getProxyError(configError, datError)}
    >
      <div className="foc-detail-main-content">
        <GraphConfigurationProvider initialData={safeConfig}>
          <GraphDataProvider initialData={safeDat}>
            <div className="relative h-full m-auto">
              <GraphsTabs
                data={safeDat as any}
                tabs={tabs}
                folderType={FolderType.Defined}
              />
            </div>
          </GraphDataProvider>
        </GraphConfigurationProvider>
      </div>
    </StatusProxy>
  );
};
